import * as types from '../../types';

export const WATCHED_AREA_FIELD_KEYS: (keyof types.AreaFormValues)[] = ['countryId', 'coords', 'address', 'tags', 'id'];
